<template>
    <v-container fluid>
        <v-card class="ma-2" outlined>
            <v-card-title>
                <v-icon class="mr-1" color="green">mdi-account-group</v-icon>
                Group
                <v-spacer></v-spacer>
                <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
                <v-btn v-if="isSuperAdmin" color="primary" dark class="ml-5" @click="goToAddGroup">
                    + Add
                </v-btn>
            </v-card-title>
            <v-data-table :headers="headers" :items="groupList" :search="search" @click:row="goToGroupView" :footer-props="{ 'items-per-page-options': [10, 20, 30, 50, 100, -1] }" :options="options" :loading="loading" :sort-by="['id']"
        :sort-desc="[true]">
                <template v-slot:[`item.desc`]="{ item }">
                    {{showText(item.description)}}
</template>
        </v-data-table>
    </v-card>
</v-container>
</template>

<script>
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import {
    mapGetters
} from "vuex";
import bqGetGroupListForOwnerAdmin from "../data/bqGetGroupListForOwnerAdmin";

export default {
    name: 'DashboardGroup',
    metaInfo: {
        title: 'Dashboard'
    },
    data() {
        return {
            options: {
                itemsPerPage: 20,
            },
            search: "",
            headers: [{
                    text: "Group #",
                    align: "start",
                    value: "id",
                    width: '8%',
                },
                {
                    text: "Name",
                    value: "name",
                    width: '20%',
                },
                {
                    text: "Members",
                    value: "member",
                    width: '10%',
                },
                {
                    text: "Description",
                    value: "desc"
                }
            ],
            groupList: [],
            challengeInfo: [],
            loading: false
        };
    },

    created() {
        var vm = this;
        vm.$store.state.appTitle = "Thaisook Web Admin";
        firebase.auth().onAuthStateChanged((user) => {
            if (user) {
                vm.$store.dispatch("autoSignIn", user);
                this.loading = true;
                setTimeout(() => {
                    vm.initialize();
                }, "1000");
            } else {
                console.log("no user");
            }
        });
    },
    computed: {
        ...mapGetters([
            "loggedInUserId",
            "isAuthenticated",
            "isSuperAdmin",
            "isChallengeAdmin",
        ]),
    },
    methods: {
        initialize() {
            if (this.loggedInUserId) {
                (async () => {
                    this.groupList = await bqGetGroupListForOwnerAdmin(this.loggedInUserId);
                    this.loading = false;
                })();
            } else {
                this.$router.push(`/dashboard`);
            }
        },
        goToGroupView(item) {
            if (localStorage.getItem('startDate')) {
                localStorage.removeItem('startDate');
            }

            if (localStorage.getItem('endDate')) {
                localStorage.removeItem('endDate');
            }
            this.$router.push(`/group/view/${item.id}`)
        },
        goToAddGroup() {
            this.$router.push(`/group/add`);
        },
        showText(text) {
            if (text.length > 50) {
                return text.substring(0, 50) + '...';
            }
            return text;
        }
    },
};
</script>